import { createContext, useContext, useState } from "react"
import { typeTaskService } from "../services/typeTaskService"

const TypeTaskContext = createContext()

export const useTypeTaskContext = () => useContext(TypeTaskContext)

export const TypeTaskProvider = ({ children }) => {
    const [typeTasks, setTypeTasks] = useState([])
    const [loadingTypeTask, setLoadingTypeTask] = useState(false)


    const getTypeTasks = async (params) => {
        try {
            setLoadingTypeTask(true)
            const response = await typeTaskService.getTypeTasks(params)
            setTypeTasks(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingTypeTask(false)
        }
    }

    const[loadingCreateTypeTask, setLoadingCreateTypeTask] = useState(false)

    const createTypeTask = async (data) => {
        try {
            setLoadingCreateTypeTask(true)
            const response = await typeTaskService.createTypeTask(data)
            setTypeTasks([...typeTasks, response.data])
            await getTypeTasks()
            return true
        } catch (error) {
            console.log(error)
            throw error
        } finally {
            setLoadingCreateTypeTask(false)
        }
    }

    return (
        <TypeTaskContext.Provider value={{ typeTasks, getTypeTasks, createTypeTask, loadingTypeTask, loadingCreateTypeTask }}>
            {children}
        </TypeTaskContext.Provider>
    )
}
